import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NumPill } from "./num-pill";
import { Badge } from "@/components/ui/badge";

export interface TabSpec {
  value: string;
  label: string;
  count?: number;
  attention?: boolean;
}

export interface TabBarProps {
  value: string;
  onValueChange: (value: string) => void;
  tabs: TabSpec[];
  ariaLabel: string;
}

export function TabBar({ value, onValueChange, tabs, ariaLabel }: TabBarProps) {
  return (
    <Tabs value={value} onValueChange={onValueChange}>
      <TabsList aria-label={ariaLabel}>
        {tabs.map((t) => {
          const attentionActive = t.attention && (t.count ?? 0) > 0;
          return (
            <TabsTrigger key={t.value} value={t.value} attention={attentionActive || undefined}>
              <span>{t.label}</span>
              {typeof t.count === "number" ? (
                attentionActive ? (
                  <Badge variant="soft">{t.count}</Badge>
                ) : (
                  <NumPill>{t.count}</NumPill>
                )
              ) : null}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
}
